import { Inject, Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { combineLatest, Observable } from 'rxjs';
import { map, shareReplay, switchMap } from 'rxjs/operators';

import { FeatureFlagService } from '@galaxy/partner';

import { AppConfigService } from '../../app-config.service';
import { FeatureFlags } from '../features';

@Injectable({
  providedIn: 'root',
})
export class FacebookAdLeadsGuard {
  constructor(
    @Inject('PARTNER_ID') private readonly partnerId$: Observable<string>,
    @Inject('MARKET_ID') private readonly marketId$: Observable<string>,
    private readonly featureFlagService: FeatureFlagService,
    private readonly configService: AppConfigService,
    private readonly router: Router,
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.userHasAccess$().pipe(map((hasAccess) => hasAccess || this.router.createUrlTree(['/access-denied'])));
  }

  userHasAccess$(): Observable<boolean> {
    const flagId = FeatureFlags.FACEBOOK_AD_LEADS_FOR_CLOUD_BROKERS;

    return combineLatest([this.partnerId$, this.marketId$]).pipe(
      switchMap(([partnerId, marketId]) => this.featureFlagService.batchGetStatus(partnerId, marketId, [flagId])),
      map((flagResponse) => this.configService.config.userIsAdmin && flagResponse && flagResponse[flagId]),
      shareReplay(1),
    );
  }
}
